/*
  getUniqueLinkId.js
*/

// Util.
import getRandomId from './getRandomId';

/**
 * Helper to get a unique ID for a link.
 */
export default function getUniqueLinkId(graphData) {

  // Get existing IDs.
  const existingIds = new Set();
  if (graphData?.links) {
    for (const link of graphData.links) {
      if (link.id) {
        existingIds.add(link.id);
      }
    }
  }

  // Generate a new unique ID.
  let id = getRandomId();
  while (existingIds.has(id)) {
    id = getRandomId();
  }
  return id;

}
